<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration Step 6 of 6
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Opt In Consent
                    </template>

                    <template #form>
                        <div class="col-span-6 mt-3">
                            <label class="flex flex-col font-normal">
                                <div class="mb-2">
                                    <strong>How Users Opt-In <span class="required">*</span></strong><br />
                                    <p>
                                        In as much detail, provide how your contacts provide consent to receive your messages. This should be what the mobile user sees when they provide their phone number to subscribe to your messages.

                                        The more detail about the opt in process, the better. The information provided for review should be clear to the Verification Ops team what specifically the customer does to opt in/sign up to receive SMS from the end-user business.

                                    </p> <br /><br />
                                    <strong>Good Example</strong>:  “Keyword Coffee. The keyword is found on a sign at the register of John’s Coffee Shop where customers can see the keyword and text in to the Toll-Free Number.”
                                    <br /><br />

                                    <strong>Good Example</strong>:  "Customers opt in when joining the Donut Reward Club, in-person (physical form) or on our website by explicitly checking a box to agree to SMS"
                                    <br /><br />

                                    <strong>Rejected Example</strong>: "Keyword/Text to join. Online. PointOfSale" <br/>
                                    <div class='italic text-gray-700'>This example does not provide enough information.</div>
                                    <br />
                                </div>
                                <span class="text-sm text-gray-500  " >Min-length: 40</span>
                                <jet-input
                                    class="mt-1 mr-2 block w-full"
                                    v-model="form.optin_message_flow"
                                    placeholder="Your answer"
                                />
                            </label>
                        </div>
                    </template>
                    <template #actions>
                        <Link :href="route('a2p.step5')" class="mr-auto" >
                            <jet-button secondary type="button">
                                Back
                            </jet-button>
                        </Link>

                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Review
                        </jet-button>
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";



export default {
    name: 'A2P-Step6',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        exampleSelectable,
    },
    data() {
        return {
            form: this.$inertia.form(
                {
                    _method: "POST",
                    optin_message_flow: this.$page.props.a2p.optin_message_flow,
                    step: 6,
                },
                {
                }
            ),
        }
    },
    computed: {
        goodToContinue() {
            return this.form.optin_message_flow && this.form.optin_message_flow.length >= 40
        },
       
    },
    mounted() {

    },
    methods: {
        saveProgress() {

            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
